import { Typography } from "@material-ui/core";
import React from "react";
import ErrorText from "../../../app/components/ErrorText";
import ConfirmDialog from "../../../app/components/modals/ConfirmDialog";
import { RequestStateDto } from "../../../app/dtos/RequestStateDto";
import { ColorsEnum } from "../../../app/enums/ColorsEnum";
import { SnapGroupCycleDto } from "../dtos/SnapGroupCycleDto";

interface Props {
  onConfirm: () => Promise<void>;
  requestState: RequestStateDto;
  cycleDto?: SnapGroupCycleDto;
}

export const confirmSnapGroupCycleDeletionDialogId =
  "delete-snap-group-cycle-confirmation-dialog";
const ConfirmSnapGroupCycleDeletionDialog: React.FC<Props> = ({
  onConfirm,
  requestState,
  cycleDto,
}) => {
  const { error, isLoading } = requestState;

  return (
    <ConfirmDialog
      title="Confirm"
      onConfirm={onConfirm}
      modalId={confirmSnapGroupCycleDeletionDialogId}
      isLoading={isLoading}
      confirmButtonText="Delete SNAP Group Cycle"
      confirmButtonStyle={{ color: ColorsEnum.Red }}
    >
      <ErrorText error={error?.message} />
      <Typography>
        Are you sure you want to delete SNAP Group Cycle{" "}
        {cycleDto?.referenceNumber}? <br />
        <br /> <strong>This action may result in invoice corrections.</strong>
      </Typography>
    </ConfirmDialog>
  );
};

export default ConfirmSnapGroupCycleDeletionDialog;
